// extracted by mini-css-extract-plugin
module.exports = {"author":"messages_author__1oCmS","container":"messages_container__3rn0B","main":"messages_main__1JjAD"};